import DescriptionIcon from '@mui/icons-material/Description';
import { handleDownload } from '../utils/downloadFile';
import noAvatarImg from "../../../assets/noAvatar.png";
// import "../scss/messageItem.scss";

const MessageItem = ({ message, isOwner, currentReceiver }) => {
    const imagesAndVideos = message.attachments?.filter(att => ['image', 'video'].includes(att.fileType || att.type)) || [];
    const audioFiles = message.attachments?.filter(att => (att.fileType || att.type) === 'audio') || [];
    const otherFiles = message.attachments?.filter(att => 
        (att.fileType || att.type) === 'file' || 
        !['image', 'video', 'audio'].includes(att.fileType || att.type)
    ) || [];

    return (
        <div className={`message ${isOwner ? "own" : ""}`}>
            {!isOwner && (
                <img 
                    // src={currentReceiver?.avatar || "/public/noAvatar.png"}
                    src={currentReceiver?.avatar || noAvatarImg}  
                    alt="" 
                    className="avatarSmall"
                />
            )}
            
            <div className="texts">
                <div className="messageContentWrapper">
                    {imagesAndVideos.length > 0 && (
                        <div className={`mediaGrid count-${imagesAndVideos.length > 4 
                                        ? 'many' 
                                        : imagesAndVideos.length}`
                                        }
                        >
                            {imagesAndVideos.map((att, index) => (
                                <div key={index} className="mediaItem">
                                    {(att.fileType || att.type) === 'image' ? (
                                        <img src={att.url} alt="attachment" loading="lazy" />
                                    ) : (
                                        <video src={att.url} controls />
                                    )}
                                </div>
                            ))}
                        </div>
                    )}

                    {audioFiles.map((att, index) => (
                        <div key={index} className="audioItem">
                            <audio controls src={att.url} />
                        </div>
                    ))}

                    {otherFiles.map((att, index) => (
                        <a 
                            key={index} 
                            href={att.url} 
                            onClick={(e) => handleDownload(e, att.url, att.name)} 
                            className="fileCard"
                        >
                            <div className="fileIcon">
                                <DescriptionIcon fontSize="large" />
                            </div>

                            <div className="file-info">
                                <span className="fileName">
                                    {att.name || "Tệp đính kèm"}
                                </span>

                                <span className="downloadText">
                                    Nhấn để tải về
                                </span>
                            </div>
                        </a>
                    ))}

                    {message.text && 
                        <p className="textContent">
                            {message.text}
                        </p>
                    }
                </div>

                {/* <span>{moment(message.createdAt).fromNow()}</span> */}
            </div>
        </div>
    );
};

export default MessageItem;